import { render, staticRenderFns } from "./VoicePlansDetails.vue?vue&type=template&id=c7c38e00&scoped=true"
import script from "./VoicePlansDetails.vue?vue&type=script&lang=ts"
export * from "./VoicePlansDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c38e00",
  null
  
)

export default component.exports